import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { Button } from 'widgets/button';
import { HorizontalLayout } from 'widgets/Layout';

import { FormElement, FormLabel } from './FormCommons';

interface FormYesNoToggleProps {
    name: string;
    label: string;
    disabled?: boolean;
    description?: string;
    yesLabel?: string;
    noLabel?: string;
    yesValue?: any;
    noValue?: any;
}
export const FormYesNoToggle = ({
    name,
    label,
    yesLabel = 'Yes',
    noLabel = 'No',
    yesValue = true,
    noValue = false,
    disabled = false,
}: FormYesNoToggleProps) => {
    const { register, watch, setValue } = useFormContext();
    register(name);
    const value = watch(name);

    return (
        <FormElement>
            <FormLabel>{label}</FormLabel>
            <Wrapper>
                <Button
                    size="small"
                    buttonType={value === noValue ? 'primary' : 'secondary'}
                    onClick={() =>
                        setValue(name, value === noValue ? undefined : noValue, {
                            shouldDirty: true,
                            shouldValidate: true,
                        })
                    }
                    disabled={disabled}
                >
                    {noLabel}
                </Button>
                <Button
                    size="small"
                    buttonType={value === yesValue ? 'primary' : 'secondary'}
                    onClick={() =>
                        setValue(name, value === yesValue ? undefined : yesValue, {
                            shouldDirty: true,
                            shouldValidate: true,
                        })
                    }
                    disabled={disabled}
                >
                    {yesLabel}
                </Button>
            </Wrapper>
        </FormElement>
    );
};

const Wrapper = styled(HorizontalLayout)`
    Button:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    Button:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
    }
`;
